import React from 'react'
import { Control, Controller, FieldError } from 'react-hook-form'
import {
  FormLabel,
  FormControl,
  FormHelperText,
  FormErrorMessage,
} from '@chakra-ui/react'
import { FieldSelectDashboardCustomProps, FieldSelect } from '.'

type FieldSelectRegistryController = FieldSelectDashboardCustomProps & {
  name: string
  label?: string
  control: Control<any>
  error?: FieldError
  helperText?: string | React.ReactNode
  shouldLabelRed?: boolean
}

export const FieldSelectController: React.FC<FieldSelectRegistryController> = ({
  name,
  label,
  error,
  control,
  helperText,
  defaultValue,
  shouldLabelRed,
  ...rest
}) => {
  return (
    <FormControl isInvalid={!!error}>
      {label && (
        <FormLabel
          fontFamily="Mulish"
          fontStyle="normal"
          fontWeight="600"
          fontSize="16px"
          lineHeight="20px"
          textAlign="left"
          letterSpacing="0.04em"
          color={shouldLabelRed && error ? '#FF6363' : '#FFFFFF'}
          htmlFor={name}
        >
          {shouldLabelRed && error ? `${label}*` : label}
        </FormLabel>
      )}

      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => <FieldSelect {...rest} {...field} />}
      />

      {helperText && <FormHelperText>{helperText}</FormHelperText>}

      {!!error && (
        <FormErrorMessage color={'red.500'}>{error.message}</FormErrorMessage>
      )}
    </FormControl>
  )
}
